/* eslint-disable no-plusplus */
/* eslint-disable import/prefer-default-export */
import Swipe from 'swipejs';
import classify from '../../helpers/classify';
import getOptions from './getOptions';

export const ID = 'cms-hero-carousel';
export const SWIPE = 'swipe';
export const SWIPE_WRAP = 'swipe-wrap';
export const NAVIGATOR_WRAPPER = 'navigator-wrapper';
export const NAVIGATOR = 'navigator';
export const NAVIGATOR_BTN = 'navigator__btn';
export const NAVIGATOR_SELECTOR = 'navigator__selector';
export const PREV = 'prev';
export const NEXT = 'next';
export const OPTIONS = 'carousel-options';

const initCarousel = (carousel: HTMLDivElement): void => {
  const slider = carousel.querySelector(classify(SWIPE)) as HTMLElement;
  const count = carousel.querySelector(classify(SWIPE_WRAP))?.childElementCount as number;
  const navigatorWrapper = carousel.querySelector(classify(NAVIGATOR_WRAPPER)) as HTMLDivElement;
  const prevBtn = carousel.querySelector(classify(PREV)) as HTMLElement;
  const nextBtn = carousel.querySelector(classify(NEXT)) as HTMLElement;
  const options = getOptions(carousel, OPTIONS);

  const swipe = new Swipe(slider, {
    startSlide: 0,
    auto: options.interval || 0,
    draggable: true,
    autoRestart: false,
    continuous: options.loop,
    disableScroll: true,
    stopPropagation: true
  });

  initNavigation(navigatorWrapper, count, swipe);

  if (options.stopOnHover) {
    carousel.addEventListener('mouseenter', () => {
      swipe.stop();
    });
    carousel.addEventListener('mouseleave', () => {
      swipe.restart();
    });
  }

  prevBtn.onclick = swipe.prev;
  nextBtn.onclick = swipe.next;
};

function initNavigation(navigatorWrapper: HTMLDivElement, count: number, swipe: Swipe): void {
  const navigator = navigatorWrapper.querySelector(classify(NAVIGATOR)) as HTMLElement;
  const selector = navigatorWrapper.querySelector(classify(NAVIGATOR_SELECTOR)) as HTMLElement;
  const width = `${100 / count}%`;
  selector?.style.setProperty('width', width);

  initNavigationBtns(navigator, count, width, swipe);

  swipe.setup({
    callback: (idx: number) => selector.style.setProperty('left', `${(idx * 100) / count}%`)
  });
}

function initNavigationBtns(navigator: HTMLElement, count: number, width: string, swipe: Swipe): void {
  for (let i = 0; i < count; i++) {
    const btn = document.createElement('a');
    btn.classList.add(NAVIGATOR_BTN);
    btn.style.setProperty('width', width);
    btn.addEventListener('click', () => swipe.slide(i, 0));
    navigator?.appendChild(btn);
  }
}

const findAllHeroCarousels = (): NodeListOf<HTMLDivElement> => document.querySelectorAll<HTMLDivElement>(classify(ID));

export function initAllHeroCarousels(): void {
  const allCarousels = findAllHeroCarousels();
  allCarousels.forEach((c) => {
    initCarousel(c);
  });
}
